import React, { FC, useState, useEffect, useContext } from 'react'

import _ from 'lodash'
import { isMobile } from 'react-device-detect'
import history from '../../../../history'

import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericColumn from '../../../../GenericComponents/GenericColumn'
import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericButton from '../../../../GenericComponents/GenericButton'

import FitmatkaJoinImage from '../../../../assets/REDESIGN_Assets/Landing/FitmatkaJoinImage.png'

import { SectionContainer, StarImage, TransformationImageButton, TransformationImageContainer, FitMatkaJoinMiazgaImage } from '../../style/LandingStyle'



interface StillHereSetionInterface { }

const StillHereSetion: FC<StillHereSetionInterface> = ({ }) => {

  const pushToLogin = () => {
    history.push("/zaloguj")
  }


  return (
    <SectionContainer className="still-here" margin={isMobile ? "10% 0 0 0" : "7% 0 0% 0"}>
      <GenericRow margin="0% 0 0 0">
        <GenericTextSpan fSize="1.1rem" color="#e39400" fWeight="bold">
          MIAZGA
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericTextSpan margin="3% 0 0 0" fSize="4.3rem" fWeight="bold">
          A Ty ciągle tutaj?
        </GenericTextSpan>
      </GenericRow>

      {/* <GenericRow margin={isMobile ? "3% 0 0 0" : "3% 0 0 25%"} width={isMobile ? "100%" : "50%"}>
        <GenericTextSpan zIndex={2} lineHeight="2rem" fSize="1.4rem" >
          Od samego przeglądania strony jeszcze nikt życia nie odmienił. Chodź już do MIAZGI, bo ja na Ciebie tam czekam!
        </GenericTextSpan>
      </GenericRow> */}
      <GenericColumn margin={"3rem 0 1.25rem 0"} >
        <GenericTextSpan margin={"0 0 2px 0"} fSize="1.02rem" fWeight="bold">Nie masz konta?</GenericTextSpan>
        <GenericRow>

          <GenericButton zIndex={isMobile ? "2" : "unset"} onClick={pushToLogin} className="standard" padding="15px 50px" borderRadius={"30px"} width="max-content"><span className="button-span">Zarejestruj się</span></GenericButton>
        </GenericRow>
      </GenericColumn>
      <FitMatkaJoinMiazgaImage src={FitmatkaJoinImage} />


    </SectionContainer>
  )
}

export default StillHereSetion
